import React, { useEffect, useRef } from 'react';
import './PortalAccess.css';

const PortalAccess = () => {
  const portalRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-now');
          } else {
            entry.target.classList.remove('reveal-now');
          }
        });
      },
      { threshold: 0.15 }
    );

    const items = portalRef.current.querySelectorAll('.animate-portal');
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="portal-section" id="portal-access" ref={portalRef}>
      <div className="portal-container">
        
        {/* Left Side: Text & Features */}
        <div className="portal-text-side animate-portal">
          <h2>Access Our <span>Healthcare Portal</span></h2>
          <p className="portal-desc">
            Connect with healthcare professionals, manage appointments, and access your medical records all in one secure platform.
          </p>

          <div className="portal-feature-list">
            <div className="p-feat">
              <div className="p-icon">📅</div>
              <span>Schedule and manage appointments with ease</span>
            </div>
            <div className="p-feat">
              <div className="p-icon">📄</div>
              <span>Access your medical records and prescriptions</span>
            </div>
            <div className="p-feat">
              <div className="p-icon">💬</div>
              <span>Communicate securely with healthcare providers</span>
            </div>
          </div>

          <div className="portal-btns">
            <button className="btn-primary">Access Doctor Portal</button>
            <button className="btn-secondary">Contact Support</button>
          </div>
        </div>

        {/* Right Side: Visual Doctor Card Preview */}
        <div className="portal-visual-side animate-portal delay-1">
          <div className="doctor-preview-card">
            <div className="doc-info-top">
              <div className="doc-avatar">👩‍⚕️</div>
              <div className="doc-details">
                <h4>Dr. Priya Sharma</h4>
                <span>General Physician</span>
                <div className="doc-rating">⭐⭐⭐⭐⭐ 4.7</div>
              </div>
              <div className="status-tag">Available Today</div>
            </div>

            <div className="portal-mini-features">
              <h5>Portal Features</h5>
              <div className="mini-grid">
                <span>✔️ Appointment Booking</span>
                <span>✔️ Medical Records</span>
                <span>✔️ Prescription Refills</span>
                <span>✔️ Secure Messaging</span>
              </div>
            </div>
          </div>
          {/* Decorative Background Glow */}
          <div className="visual-glow"></div>
        </div>

      </div>
    </section>
  );
};

export default PortalAccess;